import React from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";

import {calculateRemSize, mb, mh, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {closeForYouModal} from "../../state/for_you_modal_slice";
import {ForYouModalButton} from "./ForYouModalButton";

const consultantImg = require("../../images/for-you-consultant.png");

export const ForYouModalSummary = () => {
    const dispatch = useDispatch();

    const onButtonClick = () => {
        dispatch(closeForYouModal());
    };

    return (
        <div css={summaryContent}>
            <div className="summary-box">
                <Image src={consultantImg} width="124px" height="124px" alt="zdjęcie konsutanta" />

                <Text variant="headline_5" as="p" align="center">
                    Anna Kowalska
                </Text>
                <Text variant="info_txt_1" align="center">
                    Twój doradca nieruchomości
                    <br />
                    Godziny pracy: <br />
                    pon-pt: 9:00-18:00
                </Text>
            </div>

            <ForYouModalButton onClick={onButtonClick} className="finish-button" />
        </div>
    );
};

const summaryContent = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: ${getThemeVariable("colors.gray.100")};
    ${p(1, 1.5, 1.5, 1.5)};
    width: 100%;
    height: 100%;
    gap: ${calculateRemSize(3)};

    .summary-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${calculateRemSize(1)};
        background-color: #fff;
        ${p(2)};
        border-radius: ${calculateRemSize(2)};
        width: 100%;
        max-width: 336px;

        img {
            ${mb(1)}
        }
    }

    .finish-button {
        width: 100%;
        background-color: inherit;
        ${p(0)};
        ${mh(0)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            width: 50%;
            margin-left: -${calculateRemSize(1.5)};
            margin-right: -${calculateRemSize(1.5)};
            ${p(2, 2, 1, 2)};
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        justify-content: center;
    }
`;
import React from "react";
import {useDispatch} from "react-redux";
import {css} from "@emotion/react";

import {calculateRemSize, mb, mh, p} from "@pg-design/helpers-css-strings";
import {Image} from "@pg-design/image-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {closeForYouModal} from "../../state/for_you_modal_slice";
import {ForYouModalButton} from "./ForYouModalButton";

const consultantImg = require("../../images/for-you-consultant.png");

export const ForYouModalSummary = () => {
    const dispatch = useDispatch();

    const onButtonClick = () => {
        dispatch(closeForYouModal());
    };

    return (
        <div css={summaryContent}>
            <div className="summary-box">
                <Image src={consultantImg} width="124px" height="124px" alt="zdjęcie konsutanta" />

                <Text variant="headline_5" as="p" align="center">
                    Anna Kowalska
                </Text>
                <Text variant="info_txt_1" align="center">
                    Twój doradca nieruchomości
                    <br />
                    Godziny pracy: <br />
                    pon-pt: 9:00-18:00
                </Text>
            </div>

            <ForYouModalButton onClick={onButtonClick} className="finish-button" />
        </div>
    );
};

const summaryContent = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: ${getThemeVariable("colors.gray.100")};
    ${p(1, 1.5, 1.5, 1.5)};
    width: 100%;
    height: 100%;
    gap: ${calculateRemSize(3)};

    .summary-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: ${calculateRemSize(1)};
        background-color: #fff;
        ${p(2)};
        border-radius: ${calculateRemSize(2)};
        width: 100%;
        max-width: 336px;

        img {
            ${mb(1)}
        }
    }

    .finish-button {
        width: 100%;
        background-color: inherit;
        ${p(0)};
        ${mh(0)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            width: 50%;
            margin-left: -${calculateRemSize(1.5)};
            margin-right: -${calculateRemSize(1.5)};
            ${p(2, 2, 1, 2)};
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        justify-content: center;
    }
`;
